
import { defineAsyncComponent } from 'vue'

const TLoading = defineAsyncComponent(() =>
    import('./loading/index.vue')
)
const AMap = defineAsyncComponent(() =>
    import('../views/map.vue')
)
const ViewRouter = defineAsyncComponent(() =>
    import('../views/viewrouter.vue')
)

const IdCard = defineAsyncComponent(() =>
    import('../views/auth/idcard.vue')
)
const CompanyCertification = defineAsyncComponent(() =>
    import('../views/auth/companycertification.vue')
)

const Setpwd = defineAsyncComponent(() =>
    import('./accountsecurity/setpwd.vue')
)
const EditPwd = defineAsyncComponent(() =>
    import('./accountsecurity/editpwd.vue')
)
const Unsubscribe = defineAsyncComponent(() =>
    import('./accountsecurity/unsubscribe.vue')
)
const InvoiceApply = defineAsyncComponent(() =>
    import('./invoice/invoice_apply.vue')
)

const InvoiceApplyProgress = defineAsyncComponent(() =>
    import('./invoice/invoice_apply_progress.vue')
)

const ReceiveEvaluation = defineAsyncComponent(() =>
    import('./evaluate/ReceiveEvaluation.vue')
)
const AnnounceEvaluation = defineAsyncComponent(() =>
    import('./evaluate/AnnounceEvaluation.vue')
)
const WaitEvaluation = defineAsyncComponent(() =>
    import('./evaluate/WaitEvaluation.vue')
)
const EditPayPwd = defineAsyncComponent(() =>
    import('./paysetting/editpaypwd.vue')
)
const ForgetPayPwd = defineAsyncComponent(() =>
    import('./paysetting/forgetpaypwd.vue')
)
const ForgetAccountPwd = defineAsyncComponent(() =>
    import('./accountsecurity/forgetpwd.vue')
)

const GoodsBasicInfo = defineAsyncComponent(() =>
    import('./shipments/goods_basic_info.vue')
)
const AssociatedOrder = defineAsyncComponent(() =>
    import('./shipments/associated_order.vue')
)

const Protocol = defineAsyncComponent(() =>
    import('./shipments/protocol.vue')
)
const ServiceticketApply = defineAsyncComponent(() =>
    import('./invoice/service_ticket_apply.vue')
)
const ServiceticketProgress = defineAsyncComponent(() =>
    import('./invoice/service_ticket_progress.vue')
)
const ServiceticketHistory = defineAsyncComponent(() =>
    import('./invoice/service_ticket_history.vue')
)
const MonthServiceticketApply = defineAsyncComponent(() =>
    import('./invoice/month_service_ticket_apply.vue')
)
const MonthServiceticketProgress = defineAsyncComponent(() =>
    import('./invoice/month_service_ticket_progress.vue')
)
const MonthServiceticketHistory = defineAsyncComponent(() =>
    import('./invoice/month_service_ticket_history.vue')
)
const DynamicInput = defineAsyncComponent(() =>
    import('./invoice/dynamicInput.vue')
)

const components = {
    DynamicInput, MonthServiceticketApply, MonthServiceticketProgress, MonthServiceticketHistory,
    ServiceticketProgress, ServiceticketApply, ServiceticketHistory,
    ViewRouter, InvoiceApplyProgress, Protocol, ForgetAccountPwd,
    EditPayPwd, ForgetPayPwd, AMap, GoodsBasicInfo, AssociatedOrder,
    TLoading, IdCard, CompanyCertification, Setpwd, EditPwd, Unsubscribe, InvoiceApply, WaitEvaluation, AnnounceEvaluation, ReceiveEvaluation
}

export default components